
export const BUSINESS_INFO = {
  name: "Sangeeta Wellness",
  legalName: "Sangeeta Wellness",
  email: "sangeetawellness2025@gmail.com",
  phone: "+919329286431",
  whatsapp: "+919329286431",
  website: "https://sangeetawellness.in/",
  taxId: "UDYAM-MP-24-0036567",
  address: {
    line1: "2230F/15 Sri Sai Parisar",
    line2: "New Kanchanpur, Adhartal",
    city: "Jabalpur",
    state: "Madhya Pradesh",
    zip: "482004",
    country: "India"
  }
};

export const COLORS = {
  primary: "teal-600",
  primaryLight: "teal-50",
  secondary: "sky-600",
  accent: "emerald-500"
};
